import { render, staticRenderFns } from "./user_index.vue?vue&type=template&id=f4c03c82&scoped=true"
import script from "./user_index.vue?vue&type=script&lang=js"
export * from "./user_index.vue?vue&type=script&lang=js"
import style0 from "./user_index.vue?vue&type=style&index=0&id=f4c03c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c03c82",
  null
  
)

export default component.exports